import { Nullable } from 'types';
import { HTTPError } from 'services/api/entities';
import { Action, isActionOfType } from '../types';
import type { BaseActionStore } from './types';
import initialState from './initialState';
import {
  BaseActionTypes,
  errorAction,
  resetErrorAction,
  startAction,
  stopAction,
} from './actions';

/* 
   removes the gives action from the actions array
*/
const filterActions = <T>(
  actions: Array<Action<T>>,
  type: string
): Array<Action<T>> =>
  actions.filter((currentAction) => currentAction.type !== type);

// /* Triggered only on STOP_ACTION (at the end of the actions chain).
//  * Loop through the actions array and check whether
//  * the action failed (is inside the errorActions array). If not
//  * then the action has succeeded
//  */
const filterSuccessActions = (
  actions: Array<Action<unknown>>,
  errorActions: Array<Action<HTTPError>>,
  successActions: Array<Action<unknown>>,
  action: Nullable<Action<unknown>>
): Array<Action<unknown>> => {
  if (action == null) return successActions;

  return actions.filter(
    (currentAction) =>
      currentAction.type === action.type &&
      !errorActions.some((errAction) => currentAction.type === errAction.type)
  );
};

const reducer = (
  state: BaseActionStore = initialState,
  action: BaseActionTypes
): BaseActionStore => {
  if (isActionOfType(action, startAction)) {
    return {
      actions: [...state.actions, action.payload],
      errorActions: [],
      successActions: [],
    };
  }

  if (isActionOfType(action, stopAction)) {
    const { type } = action.payload;
    return {
      ...state,
      actions: filterActions(state.actions, type),
      successActions: filterSuccessActions(
        state.actions,
        state.errorActions,
        state.successActions,
        action.payload
      ),
    };
  }

  if (isActionOfType(action, errorAction)) {
    return {
      ...state,
      errorActions: [...state.errorActions, action.payload],
    };
  }

  if (isActionOfType(action, resetErrorAction)) {
    const { type } = action.payload;
    return {
      ...state,
      errorActions: filterActions(state.errorActions, type),
    };
  }

  return state;
};

export default reducer;
